import axios from 'axios'
import proveedor from '../Registroproveedores.vue'
export default {
  name: 'Registro',
  components: { proveedor },
  data () {
    return {
      avisos: [], mail: '', celular: '', nombre: '', direccion: '', pass: '', proveedores: [], barracas: ''
    }
  },
  mounted() {
  },
  methods: {
    registrodeplak: function (event) {
      if (this.verificarform() === true){
        event.preventDefault();
        event.stopPropagation();
        this.enviarregistroapi()
      }
    },
    atras () {
      this.$router.push('/listador')
    },
    iralogin () {
      this.$router.push('/login')
    },
    verificarform: function (event) {
      this.avisos = []
      if (this.nombre === '') {
        this.avisos.push("Indique su Nombre")
      }
      if (this.celular === '') {
        this.avisos.push("Indique su Celular")
      } else {
        if (this.verificarcelular(this.celular) === false) {
          this.avisos.push("Número de Celular no válido")
        }
      }
     
      if(!this.avisos.length) {
        return true
      } else {
        return false
      }
    },
    verificarcelular (actual) {
    var re = /(\d{3})(\d{3})(\d{3})/g;
    var nuevo = actual.replace(re, "$1$2$3");
    var codigo = actual.replace(re, "$1");
      
      if(codigo <= 99){
      switch(codigo) {
      case '091':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '092':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '093':
         if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '094':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '095':
         if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '096':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '097':
         if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '098':
         if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '099':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      default:
          return false;
  }
      }else{
          return false;
      }
    },
    enviarregistroapi () {
      let carpintero = []
      carpintero.push({'nombre': this.nombre, 'tel': this.celular})  
      axios.post(this.$apibase+'gen/registro/', {
          "usuario": carpintero, 2006: 1
      })
      .then( response => this.pasoregistroapi(response),  response => this.errorregistroapi(response) )
      .catch( response => this.errorregistroapi(response))
    },
    pasoregistroapi: function (respuesta) {
      if (respuesta.data.estado === 1 && respuesta.data.credenciales) {
          this.$store.dispatch('SET_CREDENCIALES', respuesta.data.credenciales)
          this.$router.push('/listador/1')
      } else {
        this.errorregistroapi(respuesta)
      }
    },
    errorregistroapi: function (respuesta) {
      if (respuesta.data.estado === "-1") {
        this.avisos = []
        this.avisos.push("El usuario ya existe, recupere su clave")
      } else if (respuesta.data.estado &&  respuesta.data.estado != 1){
        this.avisos = []
        this.avisos.push("Error en los datos enviados")
      }
    },
    cambiarproveedor: function (valor) {
      console.log(valor)
    }
  },
  computed: {
  },
  watch: {
  }
}


// WEBPACK FOOTER //
// ./src/components/js/registro.js